import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class NavigationStateService {
  private navigationStatusSubject = new Subject<any>();
  private navigationIndexStatusSubject = new Subject<any>();

  constructor() { }

  triggerNavigationStatus(data: any) {
    this.navigationStatusSubject.next(data);
  }

  handleNavigationStatus(): Observable<any> {
    return this.navigationStatusSubject.asObservable();
  }

  triggerNavigationIndexStatus(data: any) {
    this.navigationIndexStatusSubject.next(data);
  }

  handleNavigationIndexStatus(): Observable<any> {
    return this.navigationIndexStatusSubject.asObservable();
  }

}




// WEBPACK FOOTER //
// ./src/app/components/dashboard/navigation/navigation.state.service.ts